import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { BaseHttpService } from 'src/app/service/base-http.service';

@Component({
  selector: 'app-dev-system-version-detail',
  templateUrl: './dev-system-version-detail.component.html',
  styleUrls: ['./dev-system-version-detail.component.css']
})
export class DevSystemVersionDetailComponent implements OnInit {
	error=null
	loading = false
  hasEditPerm = false;
  submitSuccess=false;
  detailForm: FormGroup = this.formBuilder.group({
    name: ["", [Validators.required, Validators.maxLength(200)]],
    version: ["", [Validators.required, Validators.maxLength(200)]],
    description: ["", [Validators.maxLength(2000)]],
    note: ["", [Validators.maxLength(2000)]],
    status: [0, [Validators.required]]
  });
  systemId=null;
  systemVersionId=null;
  systemVersionAction="create";

  statusOptionList=[
    {value:0,label:"Ngừng sử dụng"},
    {value:1,label:"Sử dụng"}
  ]

  constructor(private authService: AuthService,private formBuilder: FormBuilder,private httpService:BaseHttpService,
    private route: ActivatedRoute,
    private router: Router ) { }

  ngOnInit(): void {
    this.authService.hasAnyPerm(['DEV_SYSTEM']).subscribe(hasPerm => {
      this.hasEditPerm = hasPerm;
    })
    this.route.params.subscribe(params=>{
      this.error=null;
      if(params.systemVersionId){
        this.systemVersionAction="view";
        if(params.systemVersionAction){
          this.systemVersionAction=params.systemVersionAction;
        }
        this.createForm();
          this.systemVersionId=params.systemVersionId;
          this.loading=true;
          this.httpService.get<any>(`/api/admin/dev/system-version/${this.systemVersionId}`).subscribe(response=>{
            this.loading=false;
            if(response.result){
              this.detailForm.patchValue(response.result);
            }else if(response.errorCode){
              this.error=response.errorCode+":"+response.errorMessage;
            }
        },errorResponse=>{
          this.loading=false;
          if(errorResponse.status==403){
            this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
            return;
          }
          if(errorResponse.status>0){
            if(errorResponse.error?.errorCode){
              this.error=errorResponse.error.errorCode+(errorResponse.error.errorMessage?":"+errorResponse.error.errorMessage:"");
              return;
            }
            this.error=errorResponse.status+":"+errorResponse.error.error+(errorResponse.error.message?":"+errorResponse.error.message:"");
            return;
          }
          this.error="Lỗi kết nối! Vui lòng thử lại sau";
        })
      }else{
        this.systemVersionAction="create";
        if(params.systemId){
          this.systemId=params.systemId;
          this.detailForm.patchValue({
            name:params.systemId
          });
        }
        this.createForm();
      }
    })
  }
  createForm(){
    if(this.systemVersionAction==="create"){
      this.detailForm.enable()
      this.detailForm.get('name').disable();
    }else if(this.systemVersionAction==="edit"){
      this.detailForm.enable()
      this.detailForm.get('name').disable();
      this.detailForm.get('version').disable();
    }else{
      this.detailForm.disable()
    }
  }

  submit(){
		if(this.loading){
			return;
		}
    this.error=null;
    if(this.systemVersionAction==="create"){
      var detailData=this.detailForm.getRawValue();
      this.loading=true;
      this.httpService.put<any>(`/api/admin/dev/system-version`,detailData).subscribe(response=>{
        this.loading=false;
      if(response.result){
        this.submitSuccess=true;
      }else if(response.errorCode){
        this.error=response.errorCode+":"+response.errorMessage;
      }
    },errorResponse=>{
      this.loading=false;
      if(errorResponse.status==403){
        this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
        return;
      }
      if(errorResponse.status>0){
        if(errorResponse.error?.errorCode){
          this.error=errorResponse.error.errorCode+(errorResponse.error.errorMessage?":"+errorResponse.error.errorMessage:"");
          return;
        }
        this.error=errorResponse.status+":"+errorResponse.error.error+(errorResponse.error.message?":"+errorResponse.error.message:"");
        return;
      }
      this.error="Lỗi kết nối! Vui lòng thử lại sau";
    })
    }
    if(this.systemVersionAction==="edit"){
      var detailData=this.detailForm.getRawValue();
      this.loading=true;
      this.httpService.post<any>(`/api/admin/dev/system-version/${this.systemVersionId}`,detailData).subscribe(response=>{
        this.loading=false;
      if(response.result){
        this.submitSuccess=true;
      }else if(response.errorCode){
        this.error=response.errorCode+":"+response.errorMessage;
      }
    },errorResponse=>{
      this.loading=false;
      if(errorResponse.status==403){
        this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
        return;
      }
      if(errorResponse.status>0){
        if(errorResponse.error?.errorCode){
          this.error=errorResponse.error.errorCode+(errorResponse.error.errorMessage?":"+errorResponse.error.errorMessage:"");
          return;
        }
        this.error=errorResponse.status+":"+errorResponse.error.error+(errorResponse.error.message?":"+errorResponse.error.message:"");
        return;
      }
      this.error="Lỗi kết nối! Vui lòng thử lại sau";
    })
    }
    if(this.systemVersionAction==="delete"){
      this.loading=true;
      this.httpService.delete<any>(`/api/admin/dev/system-version/${this.systemVersionId}`).subscribe(response=>{
        this.loading=false;
      if(response.result){
        this.submitSuccess=true;
      }else if(response.errorCode){
        this.error=response.errorCode+":"+response.errorMessage;
      }
    },errorResponse=>{
      this.loading=false;
      if(errorResponse.status==403){
        this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
        return;
      }
      if(errorResponse.status>0){
        if(errorResponse.error?.errorCode){
          this.error=errorResponse.error.errorCode+(errorResponse.error.errorMessage?":"+errorResponse.error.errorMessage:"");
          return;
        }
        this.error=errorResponse.status+":"+errorResponse.error.error+(errorResponse.error.message?":"+errorResponse.error.message:"");
        return;
      }
      this.error="Lỗi kết nối! Vui lòng thử lại sau";
    })
    }
  }
  cancel(){
    if(this.systemVersionAction==="create"){
      this.router.navigate(['../'], { relativeTo: this.route });
    }else{
      this.router.navigate(['../../'], { relativeTo: this.route });
    }
  }
}
